import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMessageCircle, FiX, FiSend } = FiIcons;

const ChatSupport = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleEmailSupport = () => {
    window.open('mailto:support@instashortlist.com?subject=Support Request');
  };

  return (
    <>
      {/* Chat Bubble */}
      <motion.button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 w-16 h-16 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-2xl flex items-center justify-center z-40 transition-colors"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 2, type: "spring", stiffness: 200 }}
      >
        <SafeIcon icon={FiMessageCircle} className="w-8 h-8" />
      </motion.button>

      {/* Chat Window */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed bottom-24 right-6 w-80 bg-white rounded-2xl shadow-2xl z-50 border border-slate-200"
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ type: "spring", duration: 0.3 }}
          >
            {/* Header */}
            <div className="bg-indigo-600 text-white p-4 rounded-t-2xl flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiMessageCircle} className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-semibold">Support Team</div>
                  <div className="text-xs text-indigo-200">Usually replies in minutes</div>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="w-6 h-6 flex items-center justify-center hover:bg-white/20 rounded transition-colors"
              >
                <SafeIcon icon={FiX} className="w-4 h-4" />
              </button>
            </div>

            {/* Messages */}
            <div className="p-4 h-64 overflow-y-auto">
              <div className="space-y-4">
                <div className="flex items-start space-x-2">
                  <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-indigo-600 font-semibold text-xs">IS</span>
                  </div>
                  <div className="bg-slate-100 rounded-2xl rounded-tl-sm p-3 max-w-[200px]">
                    <p className="text-sm text-slate-700">
                      Hi! 👋 I'm here to help you with any questions about Instashortlist. What would you like to know?
                    </p>
                  </div>
                </div>

                <div className="space-y-2">
                  <button
                    onClick={handleEmailSupport}
                    className="w-full text-left bg-slate-50 hover:bg-slate-100 rounded-lg p-3 transition-colors"
                  >
                    <div className="font-medium text-slate-900 text-sm">📧 Email Support</div>
                    <div className="text-xs text-slate-600">Get detailed help via email</div>
                  </button>
                  
                  <button
                    onClick={() => {
                      const element = document.getElementById('pricing');
                      element?.scrollIntoView({ behavior: 'smooth' });
                      setIsOpen(false);
                    }}
                    className="w-full text-left bg-slate-50 hover:bg-slate-100 rounded-lg p-3 transition-colors"
                  >
                    <div className="font-medium text-slate-900 text-sm">💰 View Pricing</div>
                    <div className="text-xs text-slate-600">See our plans and pricing</div>
                  </button>

                  <button
                    onClick={() => {
                      const element = document.getElementById('faq');
                      element?.scrollIntoView({ behavior: 'smooth' });
                      setIsOpen(false);
                    }}
                    className="w-full text-left bg-slate-50 hover:bg-slate-100 rounded-lg p-3 transition-colors"
                  >
                    <div className="font-medium text-slate-900 text-sm">❓ FAQ</div>
                    <div className="text-xs text-slate-600">Common questions answered</div>
                  </button>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-slate-200">
              <div className="text-xs text-slate-500 text-center">
                Powered by Instashortlist Support
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Backdrop for mobile */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed inset-0 bg-black/20 z-30 lg:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default ChatSupport;